export enum OfferStatus {
  RESPONDED = 'Responded',
  EXPIRED = 'Expired',
  REJECTED = 'Rejected',
  CONTRACTED = 'Contracted',
  DRAFT = 'Draft',
}
